import { ApiMotorCalculoEnum } from '@shared/enums/formula/api-motor-calculo.enum';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCicloEmpresaRascunho } from '@shared/services/structs/formula/formula-ciclo-empresa-rascunho.struct';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';

/** Valor inicial de uma entrada da simulação; a tela informa o que já conhece (alíquotas, markup, quantidade). */
export class FormulaSimulacaoEntradaInicial {
    chaveVariavel: string;
    valor: number | boolean;
}

/** Dados do modal genérico de simulação; o modal não conhece DIFAL, custo nem venda. */
export class FormulaSimulacaoDialogData {
    titulo: string;
    subtitulo?: string;
    /** Decide qual service `MotorCalculo` é chamado. */
    api: ApiMotorCalculoEnum;
    /** Chave do contexto raiz (filhos incluídos) cujas fórmulas participam da simulação. */
    contextoRaiz: string;
    /** Fórmulas do contexto, na projeção dos cards. */
    formulasCatalogo: FormulaCatalogoItemStruct[];
    /** Estado em edição da tela, inclusive alterações ainda não salvas. */
    estados: FormulaItemStruct[];
    /** Somente MotorFiscal. */
    ciclosEmpresa?: FormulaCicloEmpresaRascunho[];
    entradasIniciais: FormulaSimulacaoEntradaInicial[];
}
